fx.ns("shared", class ErrorHandling extends fx.ErrorHandling {

    constructor()
    {
        super();

        this.DELAY_CHECK_ERRORS = 5000;

        //this.delay(this._checkErrors, this.DELAY_CHECK_ERRORS);
    }

    get bookid()
    {
        return this._bookid;
    }

    set bookid(val)
    {
        this._bookid = val;
    }

    get accountid()
    {
        return this._accountid;
    }

    set accountid(val)
    {
        this._accountid = val;
    }


    /**
     * 
     * @param {Object} data : msg, url, line, col, error, delay
     * @param {*} type : ajax / js
     */
    log(data, type)
    {
        let error, request;
        if (type == "js")
            error = (data.error && data.error.stack) ? data.error.stack : data.error;
        else
        {
            error = data ? (data.error || data.details) : "";
            request = data ? data.request : {};

            if (typeof error != "string")
                error = JSON.stringify(error);

            if (typeof request != "string")
                request = JSON.stringify(request);
        }

        // TODO
        this.post( 
            "/app/log",
            { 
                type : type,
                creation_id : this.creationid, 
                accountid : this.accountid,
                msg : ((data ? (data.msg || data.details) : "") || "").toString(), 
                url : window.location.href, 
                line : data ? (data.line || 0) : 0, 
                column : data ? (data.column || 0) : 0, 
                error : error, 
                request : request,
                delay : data ? (data.delay || this.timestamp ) : this.timestamp
            }, 
            this._logged
        );
    }

    _logged(data)
    {
        // let's store it in local storage. Next time editor is opened, we will try to send it
        if (data.error)
            this._storeErrors(data);
    }

    _storeErrors(data)
    {
        /*let failedLogs = this.read("failed_logs");
        if (!failedLogs || !(failedLogs instanceof Array))
            failedLogs = [];
      
        // we store only the last 10 failed_logs
        if (failedLogs.length > 10)
            failedLogs.shift();
        
        failedLogs.push(data.request.data);
        
        this.store("failed_logs", failedLogs);

        this.delay(this._checkErrors, this.DELAY_CHECK_ERRORS);*/
    }

    _checkErrors()
    {
        /*let failedLogs = this.read("failed_logs");
        if (failedLogs && failedLogs.length > 0) 
        {
            for (let i = 0; i < failedLogs.length; i++)
            {
                let failedLog = failedLogs[i];
                this.log( failedLog, failedLog.type );
            }
        }

        this.remove("failed_logs");*/
    }
});
